import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_inbound_order_summary_reportService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { orderIds?: number[], projectId?: number, fromDate?: string, toDate?: string }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, GrossWeight?: number, NetWeight?: number, OrderLine?: { OrderId?: number, Order?: { LookupCode?: string, OwnerReference?: string, Project?: { LookupCode?: string, Name?: string } }, Material?: { Description?: string, LookupCode?: string }, Lot?: { LookupCode?: string } }, Shipment?: { ShippedDate?: string }, ContentListForShipmentLine?: { LotId?: number, Lot?: { LookupCode?: string } }[] }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { orderIds?: number[], projectId?: number, fromDate?: string, toDate?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, GrossWeight?: number, NetWeight?: number, OrderLine?: { OrderId?: number, Order?: { LookupCode?: string, OwnerReference?: string, Project?: { LookupCode?: string, Name?: string } }, Material?: { Description?: string, LookupCode?: string }, Lot?: { LookupCode?: string } }, Shipment?: { ShippedDate?: string }, ContentListForShipmentLine?: { LotId?: number, Lot?: { LookupCode?: string } }[] }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { orderIds?: number[], projectId?: number, fromDate?: string, toDate?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, GrossWeight?: number, NetWeight?: number, OrderLine?: { OrderId?: number, Order?: { LookupCode?: string, OwnerReference?: string, Project?: { LookupCode?: string, Name?: string } }, Material?: { Description?: string, LookupCode?: string }, Lot?: { LookupCode?: string } }, Shipment?: { ShippedDate?: string }, ContentListForShipmentLine?: { LotId?: number, Lot?: { LookupCode?: string } }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      orderIds?: number[], projectId?: number, fromDate?: string, toDate?: string    }) {
      return false;
    }
}
